import { render, staticRenderFns } from "./level2ImportInpatient.vue?vue&type=template&id=ac00ef7a&scoped=true&"
import script from "./level2ImportInpatient.vue?vue&type=script&lang=js&"
export * from "./level2ImportInpatient.vue?vue&type=script&lang=js&"
import style0 from "./level2ImportInpatient.vue?vue&type=style&index=0&id=ac00ef7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac00ef7a",
  null
  
)

export default component.exports